/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Compass(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M127.99975,24a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,127.99975,24Zm52.34961,62.124-28.09472,62.14209a7.99954,7.99954,0,0,1-4.13868,4.05713L88.71948,177.7793A7.99971,7.99971,0,0,1,78.2146,167.27539l25.45507-59.39746a8.00275,8.00275,0,0,1,4.043-4.13086L169.74878,75.5459A8,8,0,0,1,180.34936,86.124Z" />
    </Svg>
  );
}

export default Compass;
